<script>
  import createDownloadLink from '@utils/create-download-link'
  import { authComputed } from '@store/helpers'
  import { fileIsDealerOnly } from "@utils/zerone-file";

  export default {
    props: {
      fileItem: {
        type: Object,
        default: () => {
          return {
            userGroupId: 6,
            categoryTitle: "測試文件",
            contentType: "image/png",
            description: null,
            downloadLink: "http://zerone.test/api/file/download/F21104EE",
            publishUp: "2021-10-27 18:55:37",
            size: "101KBBytes",
            title: "sdfsdfsdfsdf",
            uuid: "F21104EE",
          }
        }
      },
      activeClass: {
        type: String,
        default: ''
      },
      disabledClass: {
        type: String,
        default: ''
      },
      isStyleRight: {
        type: Boolean,
        default: false
      }
    },
    data(){
      return {
        filedoading: false,
      }
    },
    computed: {
      ...authComputed,
      isDealerOnly() {
        return fileIsDealerOnly({ ...this.fileItem })
      },
      showDownload() {
        let result; 
        if(this.isDealerOnly){ 
          if( this.loggedIn && this.currentMember.groupId === 6 ) { 
            if(this.fileItem.downloadLink) {
              result = 'canDownLoad'
            } else {
              result = 'DealerNotVali'
            }
          } else {
            result = 'DealerOnly'
          }
        } else if(this.fileItem.userGroupId === 7) {
          if(this.loggedIn) {
            result = 'canDownLoad'
          } else {
            result = 'groupOnly'
          }
        } else {
          result = 'canDownLoad'
        }
        return result
      },
    },
    methods: {
      async handleDownloadFile(file) {
        this.filedoading = true;
        const response = await this.$store.dispatch('global/fetchFile', {
          url: file.downloadLink,
          responseType: 'blob'
        });

        createDownloadLink(file.title||file.name, response);
        this.filedoading= false
      },
    }
  }
</script>
<template>
  <div v-if="isStyleRight">
    <template v-if="!!fileItem.size || !!fileItem.webLink">
      <template v-if="showDownload === 'canDownLoad'">
        <BaseButton
          v-if="fileItem.linkType === 'url'"
          v-loading="filedoading"
          class="isText"
          :href="fileItem.webLink"
          target="_blank"
        >
          <i class="icomoon icon-download mr-2"></i>
          下載
        </BaseButton>
        <BaseButton
          v-else
          v-loading="filedoading"
          class="isText"
          @click="handleDownloadFile(fileItem)"
        >
          <i class="icomoon icon-download mr-2"></i>
          下載
        </BaseButton>
      </template>
      <div v-else-if="showDownload === 'groupOnly'">
        <el-tooltip  placement="top">
          <div slot="content">
            會員限定
          </div>
          <el-button class="isStyleFile">
            <i class="fal fa-times-circle color-gray-5"></i>
          </el-button>
        </el-tooltip>
      </div>
      <div v-else>
        <el-tooltip  placement="top">
          <div slot="content">
            {{ showDownload === 'DealerNotVali' ? '經銷會員未驗證' : '經銷商限定'}}
          </div>
          <el-button class="isStyleFile">
            <i class="fal fa-times-circle color-gray-5"></i>
          </el-button>
        </el-tooltip>
      </div>
    </template>
  </div>
  <div v-else>
    <template v-if="!!fileItem.size || !!fileItem.webLink">
      <template v-if="showDownload === 'canDownLoad'">
        <BaseButton
          v-if="fileItem.linkType === 'url'"
          v-loading="filedoading"
          class="isStylePrimary isSmall isRadius isOutline2 isFull w-100"
          :href="fileItem.webLink"
          target="_blank"
        >
          <i class="icomoon icon-download mr-2"></i>
          下載
        </BaseButton>
        <BaseButton
          v-else
          v-loading="filedoading"
          class="isStylePrimary isSmall isRadius isOutline2 isFull w-100"
          @click="handleDownloadFile(fileItem)"
        >
          <i class="icomoon icon-download mr-2"></i>
          下載
        </BaseButton>
      </template>
      <div v-else-if="showDownload === 'groupOnly'">
        <span class="color-primary">會員限定</span>
      </div>
      <div v-else>
        <span class="color-primary">{{ showDownload === 'DealerNotVali' ? '經銷會員未驗證' : '經銷商限定'}}</span>
      </div>
    </template>
   
  </div>
</template>
